import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-asahhome',
    templateUrl: './asahhome.component.html',
    styleUrls: ['./asahhome.component.scss']
})
export class AsahhomeComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Arts and Humanities Degree at ARNI School of Arts and Humanities');
        this.meta.updateTag({
            name: 'description',
            content: `Discover an arts and humanities degree at ARNI School of Arts and Humanities. Gain valuable skills and knowledge for a thriving career in business.`
        });
    }

}
